var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import { personNameInitials, removeHashRevokeUserEmail, } from '@/shared/utils/helpers';
import { translateRole } from '@/shared/utils/translate';
let UsersListItem = class UsersListItem extends Vue {
    constructor() {
        super(...arguments);
        this.translateRole = translateRole;
        this.operation = {
            add_credit: 'Adição',
            remove_credit: 'Remoção',
            invalidate_unlimited_credit: 'Remoção',
        };
    }
    userNameInitials(name) {
        return personNameInitials(name);
    }
    get userEmail() {
        if (this.user.active) {
            return this.user.email;
        }
        else {
            return removeHashRevokeUserEmail(this.user.email);
        }
    }
    openDetails() {
        this.$emit('click', this.user);
    }
};
__decorate([
    Prop({ default: () => { } })
], UsersListItem.prototype, "user", void 0);
__decorate([
    Prop({ default: () => [] })
], UsersListItem.prototype, "columns", void 0);
UsersListItem = __decorate([
    Component
], UsersListItem);
export default UsersListItem;
